export const STATUS_COLORS = {
  sky: "bg-sky-900/50 text-sky-200 border-sky-700/60", amber: "bg-amber-900/50 text-amber-200 border-amber-700/60",
  blue: "bg-blue-900/50 text-blue-200 border-blue-700/60", teal: "bg-teal-900/50 text-teal-200 border-teal-700/60",
  orange: "bg-orange-900/50 text-orange-200 border-orange-700/60", red: "bg-red-900/60 text-red-200 border-red-600",
  emerald: "bg-emerald-900/50 text-emerald-200 border-emerald-600/60", lime: "bg-lime-900/50 text-lime-200 border-lime-700/60",
  violet: "bg-violet-900/50 text-violet-200 border-violet-700/60", yellow: "bg-yellow-900/50 text-yellow-200 border-yellow-700/60",
  cyan: "bg-cyan-900/50 text-cyan-200 border-cyan-700/60", zinc: "bg-zinc-800 text-zinc-300 border-zinc-600",
  indigo: "bg-indigo-900/50 text-indigo-200 border-indigo-700/60", green: "bg-green-900/60 text-green-200 border-green-600",
  stone: "bg-stone-800 text-stone-400 border-stone-600",
};

export const fmtDT = (s) => {
  if (!s) return "—";
  try { return new Date(s).toLocaleString("fr-CA", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" }); } catch { return s; }
};
export const fmtD = (s) => {
  if (!s) return "—";
  try { return new Date(s.length <= 10 ? s + "T12:00" : s).toLocaleDateString("fr-CA", { day: "numeric", month: "short", year: "numeric" }); } catch { return s; }
};

export const StatusBadge = ({ code, statuses, testid }) => {
  const st = statuses?.[code] || { label: code, color: "zinc", definition: "" };
  return (
    <span title={st.definition} data-testid={testid || `ti-status-${code}`}
      className={`inline-flex items-center text-[11px] font-semibold px-2 py-0.5 rounded-full border cursor-help ${STATUS_COLORS[st.color] || STATUS_COLORS.zinc}`}>
      {st.label}
    </span>
  );
};

export const inputCls = "w-full bg-zinc-950 border border-zinc-700 rounded-lg px-3 py-2 text-sm text-zinc-100 focus:border-amber-500 focus:outline-none";
export const labelCls = "block text-[11px] uppercase tracking-wide text-zinc-500 mb-1";
